<template>
    <div class="card wos__card rounded-lg m-4 shadow justify-content-between w-100">
        <div class="card-header">
            <a href="javascript:void(0)">
                <span class="discount-badge">
                    {{`${quantity} ${unit}`}}
                </span>
                <img class="card-img-top wos__image-link top-rounded-img_lg" :alt="catalogNo" :src="thumbnail">
            </a>
        </div>
        <div class="card-body">
            <h4 class="card-title wos__card-title w-100 text-overflow-hide">{{catalogName}}</h4>
            <a class="text-wellis-gold" href="javascript:void(0)">
                <h6 class="card-subtitle mb-2">{{catalogNo}}</h6>
            </a>
            <button class="btn btn-sm btn-outline-wellis-black col-sm-12 mt-5 text-left" @click="showStocklist"
                    :disabled="quantityStocklist === 0">
                {{$t('components.stocklist.title')}}<span class="ml-2 text-wellis-gold">{{`${quantityStocklist} ${unit}`}}</span>
            </button>

            <button class="btn btn-sm btn-outline-wellis-black col-sm-12 mt-2 text-left" @click="showShopOrd"
                    :disabled="quantityShopOrd === 0">
                {{$t('components.shopord.title')}}<span class="ml-2 text-wellis-gold">{{`${quantityShopOrd} ${unit}`}}</span>
            </button>
        </div>
        <transition name="bounce">
            <StockFifoProductConfigurations v-if="showStocklistModal"
                                            :configurations="stocklist"
                                            :catalog-no="catalogNo"
                                            :name="catalogName"
                                            :btn-configurator="btnConfigurator"
                                            :btn-add-cart="btnAddCart"
                                            @close="toggleStocklistModal"/>
        </transition>
        <transition name="bounce">
            <StockMixedShopOrdItems v-if="showShopOrdModal"
                                    :shopord="shopord"
                                    :catalog-no="catalogNo"
                                    :name="catalogName"
                                    :btn-configurator="btnConfigurator"
                                    :btn-add-cart="btnAddCart"
                                    @close="toggleShopOrdModal"/>
        </transition>
    </div>
</template>

<script>
import StockFifoProductConfigurations from "@/components/application/StockFifoProductConfigurations";
import StocklistApiService from "@/api/stocklist.api";
import StockMixedShopOrdItems from "@/components/application/StockMixedShopOrdItems";
import ShopOrdApiService from "@/api/shopord.api";

export default {
    name: "StockMixedProductCard",
    components: {StockMixedShopOrdItems, StockFifoProductConfigurations},
    props: {
        stockItem: Object,
        btnConfigurator: Boolean,
        btnAddCart: Boolean
    },

    created() {
        this.product = this.stockItem;
    },

    data() {
        return {
            product: {},
            showStocklistModal: false,
            showShopOrdModal: false
        }
    },

    methods: {
        toggleStocklistModal() {
            this.showStocklistModal = !this.showStocklistModal;
            if (this.showStocklistModal) {
                document.body.classList.add('overflow-hidden');
            } else {
                document.body.classList.remove('overflow-hidden');
            }
        },

        toggleShopOrdModal() {
            this.showShopOrdModal = !this.showShopOrdModal;
            if (this.showShopOrdModal) {
                document.body.classList.add('overflow-hidden');
            } else {
                document.body.classList.remove('overflow-hidden');
            }
        },

        showStocklist() {
            let loader = this.$loading.show();
            let data = [];
            Object.values(this.product.stocklist).forEach(item => {
                data.push({
                    catalog_no: this.product.catalogNo,
                    config_no: item.configNo,
                    contract: item.contract
                });
            });

            StocklistApiService.getConfigurationsPrice(data)
                .then(response => {
                    const configs = Object.values(response.data.configs);
                    Object.values(this.product.stocklist).forEach(item => {
                        let config = configs.find(x => x.config_no === item.configNo);
                        if (config) {
                            item.price = config.price;
                        }
                    });
                    this.toggleStocklistModal();
                })
                .finally(() => {
                    loader.hide();
                    loader = null;
                });
        },

        showShopOrd() {
            let loader = this.$loading.show();
            let data = [];
            Object.values(this.product.shopord).forEach(item => {
                data.push(item.uniqueId);
            });

            ShopOrdApiService.getItemsPrice(data)
                .then(response => {
                    const prices = Object.values(response.data.prices);
                    Object.values(this.product.shopord).forEach(item => {
                        let shopordItem = prices.find(x => x.uniqueId === item.uniqueId);
                        if (shopordItem) {
                            item.price = shopordItem.price;
                        }
                    });
                    this.toggleShopOrdModal();
                })
                .finally(() => {
                    loader.hide();
                    loader = null;
                });
        }
    },

    computed: {
        catalogNo() {
            if (!this.product) {
                return 'N/A';
            }
            return this.product.catalogNo;
        },

        catalogName() {
            if (!this.product) {
                return 'N/A';
            }
            return this.product.name;
        },

        thumbnail() {
            if (!this.product) {
                return null;
            }
            return this.product.media.thumbnailUrl;
        },

        stocklistCount() {
            if (!this.product) {
                return null;
            }
            return Object.values(this.product.stocklist).length;
        },

        shopOrdCount() {
            if (!this.product) {
                return null;
            }
            return Object.values(this.product.shopord).length;
        },

        quantity() {
            if (!this.product) {
                return 0;
            }

            return this.quantityStocklist + this.quantityShopOrd;
        },

        quantityStocklist() {
            if (!this.product) {
                return 0;
            }
            let quantity = 0;
            Object.values(this.product.stocklist).forEach(item => {
                quantity += parseInt(item.quantity);
            });
            return quantity;
        },

        quantityShopOrd() {
            if (!this.product) {
                return 0;
            }
            let quantity = 0;
            Object.values(this.product.shopord).forEach(item => {
                if (item.hidden !== true) {
                    quantity += parseInt(item.quantity);
                }
            });
            return quantity;
        },

        unit() {
            if (!this.product) {
                return 'N/A';
            }
            return this.product.unit;
        },

        stocklist() {
            return Object.values(this.product.stocklist);
        },

        shopord() {
            return this.product.shopord;
        },
    }
}
</script>

<style scoped>
.discount-badge {
    position: absolute;
    right: 0;
    font-size: 14px;
}


.bounce-enter-active {
    animation: bounce-in .5s;
}

.bounce-leave-active {
    animation: bounce-in .5s reverse;
}

@keyframes bounce-in {
    0% {
        transform: scale(0);
    }
    50% {
        transform: scale(1.5);
    }
    100% {
        transform: scale(1);
    }
}
</style>
